(function (m, $) {

    m.init = function () {
        var allVideos = $("iframe[src^='//player.vimeo.com'], iframe[src^='//www.youtube.com']");
        var fluidEl = $(".ux-video");

        allVideos.each(function () {
            var videoElement = $(this);
            videoElement.data("aspectRatio", videoElement.height() / videoElement.width());
            videoElement.removeAttr("height");
            videoElement.removeAttr("width");
        });

        $(window).resize(function () {
            var newWidth = fluidEl.width();

            allVideos.each(function () {
                var videoElement = $(this);
                videoElement.width(newWidth);
                videoElement.height(newWidth * videoElement.data("aspectRatio"));
            });
        }).resize();
    };

}(window.ooooby = window.ooooby || {}, jQuery));

$(document).ready(function () {
    ooooby.init();
});